import { EnumSiNoTodos, FilterSearchingBaseViewModel, PagingResultsViewModel } from 'src/app/components/core/_infrastructure/types/common';

export class ConfiguracionTaricViewModel {
    public Id: number;
    public CodigoTaric: string;
    public Higiene: boolean;
    public ChedPp: boolean;
    public PcfCanariasSv: boolean;
}

export class ConfiguracionTaricItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: ConfiguracionTaricItemViewModel[];
}

export class ConfiguracionTaricItemViewModel {
    public Id: number;
    public CodigoTaric: string;
    public Higiene: boolean;
    public ChedPp: boolean;
    public PcfCanariasSv: boolean;
}

export class FilterSearchingConfiguracionTaricViewModel extends FilterSearchingBaseViewModel {
    public CodigoTaric: string;
    public Higiene: number = EnumSiNoTodos.TODOS;
    public ChedPp: number = EnumSiNoTodos.TODOS;
    public PcfCanariasSv: number = EnumSiNoTodos.TODOS;
}
